// Musculoskeletal subsection questionnaire constants
export enum MusculoskeletalQuestionnaireItem {
  MEDICAL_BACKGROUND_MUSCULOSKELETAL = 'medical-background/musculoskeletal',
  MEDICAL_BACKGROUND_MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT = 'medical-background/musculoskeletal/musculoskeletal-assessment',
  MEDICAL_BACKGROUND_MUSCULOSKELETAL_SYSTEM_SUMMARY = 'medical-background/musculoskeletal/system-summary'
}
